import { render, staticRenderFns } from "./ParticipantsIcon.vue?vue&type=template&id=1e8a725f&"
import script from "./ParticipantsIcon.vue?vue&type=script&lang=js&"
export * from "./ParticipantsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports